export const PAGE_PATH = '/auth/login';
